import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "nav-sidebar-collapsed"
const AUTO_COLLAPSE_QUERY = "(max-width: 1279px)"

export default class extends Controller {
  static targets = [
    "sidebar",
    "label",
    "chevron",
    "header",
    "userButton",
    "logoLink",
    "tooltip",
    "userMenu",
    "navLink",
  ]

  connect() {
    this.userCollapsed = localStorage.getItem(STORAGE_KEY) === "true"
    this.autoCollapsed = false
    this.logoHref = this.logoLinkTarget.getAttribute("href")
    this.handleLogoClick = this.handleLogoClick.bind(this)
    this.logoLinkTarget.addEventListener("click", this.handleLogoClick)

    this.mediaQuery = window.matchMedia(AUTO_COLLAPSE_QUERY)
    this.handleMediaChange = this.handleMediaChange.bind(this)
    this.mediaQuery.addEventListener("change", this.handleMediaChange)

    this.handleMediaChange(this.mediaQuery)
  }

  disconnect() {
    this.logoLinkTarget.removeEventListener("click", this.handleLogoClick)
    this.mediaQuery.removeEventListener("change", this.handleMediaChange)
  }

  handleMediaChange(e) {
    const matches = e.matches !== undefined ? e.matches : e
    if (matches) {
      this.autoCollapsed = true
      this.collapsed = true
    } else {
      this.autoCollapsed = false
      this.collapsed = this.userCollapsed
    }
    this.apply(false)
  }

  handleLogoClick(event) {
    if (this.collapsed) {
      event.preventDefault()
      this.toggle()
    }
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.userCollapsed = this.collapsed
    this.autoCollapsed = false
    localStorage.setItem(STORAGE_KEY, this.collapsed)
    this.apply(true)
  }

  showTooltip(event) {
    if (!this.collapsed) return
    const link = event.currentTarget
    const index = this.navLinkTargets.indexOf(link)
    if (index >= 0 && this.tooltipTargets[index]) {
      this.tooltipTargets[index].classList.remove("hidden")
    }
  }

  hideTooltip(event) {
    const link = event.currentTarget
    const index = this.navLinkTargets.indexOf(link)
    if (index >= 0 && this.tooltipTargets[index]) {
      this.tooltipTargets[index].classList.add("hidden")
    }
  }

  apply(animate) {
    const sidebar = this.sidebarTarget

    if (animate) {
      sidebar.style.transition = "width 200ms cubic-bezier(0.4, 0, 0.2, 1)"
      sidebar.addEventListener(
        "transitionend",
        () => {
          sidebar.style.transition = ""
        },
        { once: true },
      )
    }

    if (this.collapsed) {
      sidebar.classList.remove("w-56")
      sidebar.classList.add("w-16")
      this.labelTargets.forEach((el) => el.classList.add("hidden"))
      this.chevronTarget.classList.add("rotate-180")
      this.headerTarget.classList.add("justify-center")
      this.userButtonTarget.classList.remove("px-3", "gap-x-3")
      this.userButtonTarget.classList.add("justify-center", "px-0")
      // User menu positioning is handled by user_menu_controller with fixed positioning
    } else {
      sidebar.classList.remove("w-16")
      sidebar.classList.add("w-56")
      this.labelTargets.forEach((el) => el.classList.remove("hidden"))
      this.chevronTarget.classList.remove("rotate-180")
      this.headerTarget.classList.remove("justify-center")
      this.userButtonTarget.classList.add("px-3", "gap-x-3")
      this.userButtonTarget.classList.remove("justify-center", "px-0")
      // Hide any visible tooltips
      this.tooltipTargets.forEach((el) => el.classList.add("hidden"))
      // User menu positioning is handled by user_menu_controller with fixed positioning
    }
  }
}
